export const NOT_FOUND_TYPES_PROJECT = 'project'



// WEBPACK FOOTER //
// ./src/constants/notFoundTypes.js